import { createContext, useContext, useState, useCallback } from "react";

const CityContext = createContext(null);
export const useCities = () => useContext(CityContext);

export function CityProvider({ children }) {
  const [cities, setCitiesState] = useState(() => {
    try { return JSON.parse(localStorage.getItem("ct_cities") || "[]"); }
    catch { return []; }
  });
  const [visitor, setVisitorState] = useState(() => localStorage.getItem("ct_visitor") || "");
  const [visitorType, setVisitorTypeState] = useState(() => localStorage.getItem("ct_visitor_type") || "");

  const setCities = useCallback((list) => {
    setCitiesState(list);
    localStorage.setItem("ct_cities", JSON.stringify(list));
  }, []);

  const clearCities = useCallback(() => {
    setCitiesState([]);
    localStorage.removeItem("ct_cities");
  }, []);

  const setVisitor = useCallback((mobile, type) => {
    setVisitorState(mobile);
    localStorage.setItem("ct_visitor", mobile);
    if (type) {
      setVisitorTypeState(type);
      localStorage.setItem("ct_visitor_type", type);
    }
  }, []);

  return (
    <CityContext.Provider value={{ cities, setCities, clearCities, visitor, visitorType, setVisitor }}>
      {children}
    </CityContext.Provider>
  );
}
